













































































import { defineComponent, ref, useContext, useFetch, useMeta } from '@nuxtjs/composition-api'
import { useHome } from '~/composables';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { PropType } from 'vue';
import { SliderType } from '~/types/solepro/PageBuilder';
import { SLIDER_CLASSES } from '~/utils/constants/solepro/pageBuilderCustomClasses';
import { Autoplay, Pagination } from 'swiper'
import { homeHeroLinkTrack } from '~/helpers/trackings/24orepro/home';

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'
import BrightcoveVideo from './BrightcoveVideo.vue';
import { getPosterImage } from '~/utils/helpers/product';

SwiperCore.use([Pagination, Autoplay])

export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<SliderType>,
            required: true
        }
    },
    head() {
        if(this.poster) {
        return {
            link: [
                { rel: 'preconnect', href: 'https://metrics.brightcove.com', crossorigin: 'anonymous' },
                {
                    rel: 'preconnect',
                    href: (this.poster as String).split('/media')[0],
                    crossorigin: 'anonymous'
                },
                {
                    rel: 'preload',
                    as: 'image',
                    href: this.poster,
                    fetchpriority: 'high'
                }
            ]
        }
      }else if(this.firstImage){
          const r = this.resizes as { [key: string]: string };
        return {
            link: [
                {
                    rel: 'preconnect',
                    href: (this.firstImage as String).split('/media')[0],
                    crossorigin: 'anonymous'
                },
                {
                    rel: 'preload',
                    as: 'image',
                    href: this.firstImage,
                    fetchpriority: 'high',
                    imagesrcset:`${this.firstImage+r.smallmobile} 767ww, ${this.firstImage+r.mobile} 1023w, ${this.firstImage+r.tablet} 1365w, ${this.firstImage+r.desktop} 1366w`,  //"wolf_400px.jpg 400w, wolf_800px.jpg 800w, wolf_1600px.jpg 1600w",
                    imagesizes:"100vw"
                }
            ]
        }
      }
    },
    components: {
        PageBuilderComponent,
        Swiper,
        SwiperSlide,
        BrightcoveVideo
        // VueSlickCarousel
    },
    setup(props, context) {
        const resizes= {
            desktop: '?resize=1366x769',
            tablet: '?resize=1366x769',
            mobile: '?resize=1024x576',
            smallmobile: '?resize=767x430'
        }
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const { app } = useContext();
        const { setHeroRendered, heroRendered } = useHome();
        const isAutoplay = content.autoplay == "true";
        const autoplaySpeed = isAutoplay ? parseInt(content.autoplaySpeed) : 0;
        const customClasses = content.cssClasses.map(el => SLIDER_CLASSES[el] ?? '').join(' ').trim();
        const swiperPagination = ref(null);
        const cardsContainer = ref(null);
        const swiperInitialized = ref(false)
        const topSlider = ref(null)
        const swiperProps = {
            loop: false, // isAutoplay || content.is_infinite == 'true', //can't use swiper loop  because of a brightcove script behavior
            slidesPerView: 1,
            loopedSlides: 0,
            slideClass: "slide",
            spaceBetween: 0,
            shortSwipes: false, longSwipesRatio: 0.1, longSwipesMs: 100,
            autoplay: {
                enabled: isAutoplay,
                delay: autoplaySpeed,
                disableOnInteraction: false
            },
            pagination: true
        };
        const hasSlider = content.children.length>1;
        if(!hasSlider){
            setHeroRendered(true)
        }
        const touchStartPosition = ref()
        const touchEndPosition = ref()
        const reachEndTimer=ref()
        const poster = ref()
        const firstImage = ref()
        const getBgImage = (jsonString)=> {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            return images.desktop_image.replace(app.$config.IMAGE_STATIC_REPLACEMENT, app.$config.IMAGE_CDN_REPLACEMENT)
        }
        
        useFetch(async ()=>{
            const firstSlide = content.children[0];
            if(firstSlide.bannerDatas.backgroundType == 'video'){
                if(firstSlide.bannerDatas?.videoSrc && firstSlide.bannerDatas?.videoSrc.includes('players.brightcove.net')){
                    const videoUrl = firstSlide.bannerDatas.videoSrc;
                    const videoPoster = await getPosterImage(videoUrl)
                    poster.value = videoPoster?.poster
                }else if(firstSlide.bannerDatas?.videoFallbackSrc){
                    poster.value = firstSlide.bannerDatas?.videoFallbackSrc
                }
            }else{
                firstImage.value = getBgImage(firstSlide.bannerDatas.backgroundImages)
            };
        })

        return {
            content,
            isAutoplay,
            heroRendered,
            setHeroRendered,
            autoplaySpeed: content.autoplay == "true" ? autoplaySpeed : null,
            customClasses,
            cardsContainer,
            swiperProps,
            swiperPagination,
            Swiper,
            hasSlider,
            swiperInitialized,
            touchStartPosition,
            touchEndPosition,
            reachEndTimer,
            isLoop: isAutoplay || content.is_infinite == 'true',
            poster,
            topSlider,
            getBgImage,
            resizes,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
            firstImage
        }
    },
    methods: {
        async trackHeroLink(buttonText, content,link,linkTargetBlank) { 
            await homeHeroLinkTrack(buttonText, content)
            if(linkTargetBlank){
                window.open(link, '_blank').focus()
            }else{
                window.location.href = link;
            }
        },
       
        updateBulletTimer(swiper) {
            //const swiper = swiperEl.detail[0];
            const previousIndex = this.getPreviousRealIndex(swiper);
            const currentIndex = this.getRealIndex(swiper);
            const lastIndex = swiper.slides.length - 1;
            const isLoopToFirst = previousIndex === lastIndex && currentIndex === 0;
            const isLoopToLast = previousIndex === 0 && currentIndex === lastIndex;
            if (!swiper.pagination.bullets) return;
            if (swiper.pagination.bullets.length) {
                if (isLoopToFirst || isLoopToLast) {
                    swiper.pagination.bullets.forEach((bullet) => {
                        this.handleTimerBulletAnimation(bullet, isLoopToFirst ? false : true);
                    })
                }
                //this.addAnimation(swiper.pagination.bullets[currentIndex], swiper.params.autoplay.delay)
                swiper.pagination.bullets.forEach((bullet, index) => {
                    if (index == parseInt(currentIndex)) {
                        this.addAnimation(bullet, swiper.params.autoplay.delay)
                    } else if (index < parseInt(currentIndex)) {
                        this.handleTimerBulletAnimation(bullet, true)
                    } else {
                        this.handleTimerBulletAnimation(bullet, false)
                    }

                })

            }
        },
        handleTimerBulletAnimation(bullet, addClass) {
            if (addClass) {
                bullet.classList.add('prev');
            } else {
                bullet.classList.remove('prev');
            }
            bullet.offsetHeight;
            bullet.querySelector(".bullet-timer").style.animation = null;
        },

        addAnimation(bullet, delay) {
            const currentBulletTimer = bullet.querySelector(".bullet-timer");
            currentBulletTimer.style.animation = `progress ${delay}ms linear forwards`;
        },
        calculateCardsContainerHeight(){
            const cardsContainer = (this.$refs.cardsContainer as HTMLElement)
            const cardsContainerChildren = Array.from(cardsContainer.children) as HTMLElement[];
            const tallest = cardsContainerChildren.reduce((tallest: HTMLElement, card: HTMLElement) => {
                return card.getBoundingClientRect().height > tallest.getBoundingClientRect().height ? card : tallest;
            });
            cardsContainer.style.height = (tallest as HTMLElement).offsetHeight+'px';
            cardsContainerChildren.forEach(child=>child.style.height = (tallest as HTMLElement).offsetHeight+'px')
        },
        init(swiper) {
            swiper.$el[0].querySelector('.swiper-wrapper').classList.add('aspect-square');
            swiper.$el[0].querySelector('.swiper-wrapper').classList.add('md:aspect-[unset]');
            if (window.innerWidth <= 1024) {
                setTimeout(()=>{
                    this.calculateCardsContainerHeight()
                },0)
            }
            
        },
        handleGoTo(swiper, index){
            swiper.slideTo(index+1)
        },
        playCurrentVideo(swiper){
            const video = swiper.slides[swiper.activeIndex].querySelector('video');
            if (video) {
                const source = video.children[0];
                if(source && source.tagName == 'SOURCE'){
                    source.src = source.getAttribute('data-src').replace('mp4:', '');
                    video.load();
                }
                video.play();
            }
        },
        afterInit(swiper) {
            this.swiperInitialized = true
            this.loadImages(0)

            const bulletTimer = document.createElement('span');
            bulletTimer.classList.add('bullet-timer')
            swiper.pagination.bullets.forEach((el, index) => {
                el.classList.add('relative')
                el.classList.add('overflow-hidden')
                el.appendChild(bulletTimer.cloneNode())
            });
            Array.from(this.$el.querySelectorAll('.swiper-pagination-bullet')).forEach((bullet, index)=>{
                bullet.classList.add('cursor-pointer')
                bullet.addEventListener('click',()=>this.handleGoTo(swiper, index))
            })
             
            this.updateBulletTimer(swiper)
            
            setTimeout(() => {
                this.setHeroRendered(true);    
            }, 0);
            
            this.playCurrentVideo(swiper)
        },
        resize(swiper) {
            this.calculateCardsContainerHeight();
        },
        loadImages(index){
            this.$el.querySelectorAll('.js-picture').forEach((pictureEl, imgIndex)=>{
                if(imgIndex == index || imgIndex == index+1 || imgIndex == index-1){
                    const imgEl = pictureEl.querySelector('img');
                    const dataSrc = imgEl.getAttribute('data-src');
                    if(dataSrc && !imgEl.getAttribute('src')){
                        imgEl.setAttribute('src', dataSrc)
                        console.log('loaded for index '+imgIndex+' - ' + Array.from(this.$el.querySelectorAll('.cards-container h2'))[imgIndex].innerHTML)
                    }
                    pictureEl.querySelectorAll('source').forEach(s=>{
                        s.setAttribute('srcset', s.getAttribute('data-srcset'))
                    })
                }
            })
        },
        slideChange(swiper) {
            const isAutoplay = this.content.autoplay == "true";
            const realIndex = this.getRealIndex(swiper);
            this.playCurrentVideo(swiper);
            this.loadImages(realIndex)
            const cardsContainer = this.$el.querySelector('.cards-container') as HTMLElement;
           // const prevCard = cardsContainer.children[prevIndex] as HTMLElement
            const currentCard = cardsContainer.children[realIndex] as HTMLElement
            Array.from(cardsContainer.children).forEach((prevCard: HTMLElement) => {
                prevCard.style.opacity = '0'
                prevCard.style.position = "absolute"
                prevCard.style.zIndex = "-1";
                const transitionContainerPrev = prevCard.querySelector(".transition-container") as HTMLElement
                transitionContainerPrev.style.transform = 'translateY(30%)'
                prevCard.setAttribute('aria-hidden', 'true');
            })
            const boundingCurrentCard = currentCard.getBoundingClientRect()
            const transitionContainer = currentCard.querySelector(".transition-container") as HTMLElement
            transitionContainer.style.transform = 'translateY(0%)'
            // currentCard.style.transform = 'translateY(0%)'
            currentCard.style.opacity = '1';
            currentCard.style.zIndex = "1";
            currentCard.setAttribute('aria-hidden', 'false');
           // if (window.innerWidth <= 1024) cardsContainer.style.maxHeight = boundingCurrentCard.height + 'px';
            if (isAutoplay) {
                this.updateBulletTimer(swiper)
            }
        },
        getRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-real-index') : 0;
        },
        getPreviousRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            if (swiper.realIndex > swiper.previousIndex) { // going next
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-prev-index') : 0;
            } else { //going backwards
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-next-index') : 0;
            }
        },
        touchStart(swiper, event){
            this.touchStartPosition = event.clientX;
        },
        touchEnd(swiper, event){
            const realMove = Math.abs(this.touchStartPosition - event.clientX) > 15;
            if(!realMove) return;
            if(this.touchStartPosition > event.clientX && swiper.realIndex == swiper.slides.length-1){
                swiper.slideTo(0)
            }else if(this.touchStartPosition < event.clientX && swiper.realIndex==0){
                swiper.slideTo(swiper.slides.length-1)
            }
        },
        reachEnd(swiper){
            this.reachEndTimer = this.isLoop ? setTimeout(()=>{
                if(this.reachEndTimer){
                     swiper.slideTo(0)
                    }
            },this.autoplaySpeed) : null;
        },
        slideChangeTransitionEnd(swiper){
            if(this.isLoop && this.reachEndTimer && swiper.realIndex!==swiper.slides.length-1) {
            this.reachEndTimer = null;    
            clearTimeout(this.reachEndTimer)
            }
        }
    },
      beforeMount(){
        if(!this.hasSlider) this.loadImages(0)
    },
    beforeDestroy(){
        Array.from(this.$el.querySelectorAll('.swiper-pagination-bullet')).forEach((bullet, index)=>{
            /** removing all event listeners */
            var new_element = bullet.cloneNode(true);
            bullet.parentNode.replaceChild(new_element, bullet);
            })
    }
})
